<template>
  <v-app>
    <v-row class="m-0">
      <v-col  class="z-index">
        <NavBar class ="hero-image" :username="username.user" :useremail="username.useremail" :userinitial="username.userinitial" />
      </v-col>
      <v-col cols="12" class="mr-top complete-page-body" style="padding-left: 65px;">
        <v-main class="" id="main-div">
          <v-sheet min-height="510" class="bg-transparent">
            <v-container fluid class="p-0">
              <router-view v-if="loggedInSuccess" />
              <h3 style="padding: 25px;margin: 0 auto;display: table;color: #707071;font-size: 12px;">Product By GDA Team</h3>
            </v-container>
          </v-sheet>
        </v-main>
      </v-col>
    </v-row>
  </v-app>
</template>
<script>
import NavBar from "@/components/NavBar.vue";
import { mapGetters, mapState } from "vuex";
import * as msal from "@azure/msal-browser";
import { PublicClientApplication } from "@azure/msal-browser";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import { AV_REQUEST_SCOPES, LOGIN_REQUEST_SCOPES } from "@/config/constants";
import { provide } from "vue";
import { store } from "./store/store.js";
import { getMsalIdToken } from "@/utils/helpers";
import { avActions } from '@/actions';
//import UnauthorizedView from "@/views/UnauthorizedView.vue";

export default {
  name: "App",
  components: {
    NavBar,
  },
  setup() {
    provide("signOutEventBus", {});
    // this.$.$emit('appBarSingOut', this.signOut());
  },
  store,
  data() {
    return {
      currentYear: new Date().getFullYear(),
      hasError: false,
      retryRequest: true,
      loggedInSuccess: false,
      unauthorized: false,
      msalLibrary: {},
      account: {},
      username: {
        user: "",
        useremail: "",
        userinitial: ""
      },
      filterData : {
        brand: [],
        productNames: [],
        tradeDirectionCodes: [],
        cargo: [],
        regions: [],
        areas: [],
        salesChannel: [],
        customers: [],
        accountManagers: [],
        accountOwners: [],
        cemMin: 0.0,
        cemMax: 0.0,
      },
      isLoadingDetails: false
    };
  },
  computed: {
    ...mapState(["accessToken"]),
    ...mapGetters({
      user: "user"
    }),
    user: {
      get() {
        const { account } = this.$store.getters.getTokenData;
        return {
          jobTitle: "",
          mail: account?.username || "",
          displayName: account?.name || ""
        };
      },
      set(userData) {
        return userData;
      }
    }
  },
  watch: {
  },
  async created() {
    this.msalLibrary = new PublicClientApplication(this.$store.state.msalConfig);
    await this.msalLibrary.initialize();
    await this.msalLibrary
        .handleRedirectPromise()
        .then(this.handleResponse)
        .catch((error) => {
          console.log(error);
          this.hasError = true;
        });
  },
  mounted() {
    const accounts = this.msalLibrary.getAllAccounts();
    this.account = accounts ? accounts[0] : null;
    // const eventBus = inject('signOutEventBus');
    // eventBus.$on('appBarSignOut', this.signOut());
  },
  methods: {
    async signIn() {
      return this.msalLibrary
          .loginRedirect(LOGIN_REQUEST_SCOPES)
          .then(this.handleResponse)
          .catch(function (error) {
            console.error(error);
          });
    },
    async signOut() {
      await this.msalLibrary
          .logout({})
          .then(() => {
            localStorage.clear(); // For Clearing Local Storage
            sessionStorage.clear(); // For Clearing Session Storage
            this.loggedInSuccess = false; //uncomment during deployment
            document.cookie.split(";").forEach(function (c) {
              // For Clearing the Cookies
              document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
          })
          .catch((error) => {
            console.error(error);
          });
    },
    async handleResponse(resp) {
      this.isLoadingDetails = true;
      if (resp !== null) {
        //alert("Not null");
        try {
          const currentAccounts = this.msalLibrary.getAllAccounts();
          const accountId = currentAccounts[0]?.homeAccountId;
          const currentAcc = this.msalLibrary.getAccountByHomeId(accountId);

          const avScopeResponse = await this.getTokenRedirect(
              AV_REQUEST_SCOPES,
              currentAcc
          ).catch((error) => {
            console.log(error);
          });
          await this.$store.dispatch("setAVAccessTokenAction", avScopeResponse);
          sessionStorage.setItem("av_msal_token", JSON.stringify(avScopeResponse));
          AxiosFetchForMsal.defaults.headers.common["Authorization"] = `Bearer ${avScopeResponse.idToken}`;
          const token = JSON.parse(sessionStorage.getItem("av_msal_token"));
          this.username.user = token.account.name == null ? "" : token.account.name;
          this.username.useremail = token.account.username == null ? "" : token.account.username;
          console.log("useremail"+this.username.useremail);
          this.username.userinitial =
              token.account.name == null
                  ? ""
                  : token.account.name.split(" ")[0].charAt(0) +
                  token.account.name.split(" ")[1].charAt(0);
          sessionStorage.setItem("userEmail", this.username.useremail);
          await this.checkAuthorization(token.idToken, token.account.username);
          this.$store.commit("setUserEmail", this.username.useremail);
          await this.saveUserActivity(token.idToken, token.account.username);
          this.loggedInSuccess = true;
        } catch(error){
          if (error.response.status === 400 && this.retryRequest) {
            this.retryRequest = false;
          } else if (error.response.status === 401) {
            await getMsalIdToken();
          }
        }
      } else {
        //alert("null");
        const currentAccounts = this.msalLibrary.getAllAccounts();
        this.account = currentAccounts[0];
        if (!currentAccounts || currentAccounts.length < 1) {
          await this.signIn();
        } else {
          const accountId = currentAccounts[0].homeAccountId;
          const currentAcc = this.msalLibrary.getAccountByHomeId(accountId);
          if (currentAcc) {
            /*const response = await this.getTokenRedirect(LOGIN_REQUEST_SCOPES, currentAcc).catch((error) => {
              console.log(error);
            });*/
            const avScopeResponse = await this.getTokenRedirect(
                AV_REQUEST_SCOPES,
                currentAcc
            ).catch((error) => {
              console.log("token fetch error:"+error);
            });

            /*await this.$store.dispatch("setAccessTokenAction", response);
            sessionStorage.setItem("msal_token", JSON.stringify(response));*/

            await this.$store.dispatch("setAVAccessTokenAction", avScopeResponse);
            sessionStorage.setItem("av_msal_token", JSON.stringify(avScopeResponse));
            AxiosFetchForMsal.defaults.headers.common["Authorization"] = `Bearer ${avScopeResponse.idToken}`;
            const token = JSON.parse(sessionStorage.getItem("av_msal_token"));
            this.username.user = token.account.name == null ? "" : token.account.name;
            this.username.useremail = token.account.username == null ? "" : token.account.username;
            this.username.userinitial =
                token.account.name == null
                    ? ""
                    : token.account.name.split(" ")[0].charAt(0) +
                    token.account.name.split(" ")[1].charAt(0);
            await this.checkAuthorization(token.idToken, token.account.username);
            await this.saveUserActivity(token.idToken, token.account.username);
            this.$store.commit("setUserEmail", this.username.useremail);
            this.loggedInSuccess = true;
          }
        }
      }
    },
    async checkAuthorization(idToken, accountId) {
      //console.log(idToken);
      //console.log(accountId);
      const userInfo = {
        "userEmail": accountId
      };
      const options = await avActions.authorizeUser(
          userInfo,
          idToken
      );
      this.isLoadingDetails = false;
      const result = await AxiosFetchForMsal(options);
      if (result.status === 200) {
        this.$store.commit("setShouldShowUnauth", false);
        this.$store.commit("setUserDetail", result.data);
        this.$store.commit("isUserAuthorized", true);
        this.loggedInSuccess = true;
        // Session storage
          // Stringify the crDropDownList object

        let jsonFilterString = undefined;
        if(result.data.crDropDownList === null){
          const crDropDownListDefault = {
            "brand": [],
            "productNames": [],
            "tradeDirectionCodes": [],
            "cargo": [],
            "regions": [],
            "areas":  [],
            "salesChannel": [],
            "customers": [],
            "customerCode": [],
            "accountManagers": ['Robert Mamacos'],
            "accountOwners": [],
            "cemMin": 0,
            "cemMax": 384
          };
          jsonFilterString = JSON.stringify(crDropDownListDefault);
        }else{
          jsonFilterString = JSON.stringify(result.data.crDropDownList);
        }
          // Store the JSON string in sessionStorage
          sessionStorage.setItem("selectedFilterData", jsonFilterString);
          AxiosFetchForMsal.defaults.headers.common["Authorization"] = 'Bearer '+idToken;
      } else {
        this.loggedInSuccess = false;
        this.$router.push("/access-denied");
        console.error("error occurred while authorizing user...");
      }
    },
    async saveUserActivity(idToken, accountId){
      const postBody = {
        "userEmail": accountId,
        "userRole": null,
        "loginTime": null
      }
      const saveOptions = await avActions.saveUserActivityDetails(
          postBody,
          idToken
      );
      const response = await AxiosFetchForMsal(saveOptions);
      if (response.status === 200) {
        console.info("user activity saved successfully.");
      } else {
        console.error("error occurred while saving user activity.");
      }
    },
    async getTokenRedirect(request, account) {
      request.account = account;
      return this.msalLibrary
          .acquireTokenSilent(request)
          .catch(async (error) => {
            console.log("silent token acquisition fails.");
            if (error instanceof msal.InteractionRequiredAuthError) {
              console.log("acquiring token using redirect");
              this.msalLibrary.acquireTokenRedirect(request);
            } else {
              console.error(error);
            }
          });
    }
  }
};
</script>
<style>
/* Please remember to replace <YOUR_BRAND> in the below path, with your desire brand name, which can be one of these: maeu, hamburgsud, safm.*/
@import "~@maersk-global/fonts/maeu/fonts-cdn.css";

/* Please remember to replace <YOUR_BRAND> in the below path, with your desire brand name, which can be one of these: maersk, hamburgsud, or sealand.*/
@import "~@maersk-global/mds-design-tokens/maersk/light/css/design-tokens-px.css";

/* You can also import `@maersk-global/mds-foundations/foundations.css`, only if you need some global stylesheet i.e. CSS resets, classes that support our typography and table styles. */
@import "~@maersk-global/mds-foundations/css/foundations.css";
.mr-left{
  margin-left: 0;
}
.mr-top{
  margin-top: 6%;
  padding-left: 5%;
}
.z-index{
  z-index:1;
}

/*#generic-detail-view .v-toolbar__content{
 height:auto !important;
}*/

#app-header.v-toolbar{
  /*height:55px !important;*/
  position: fixed;
  z-index: 11;
}

.v-application .maersk-primary-color {
  background-color: #42b0d5 !important;
  border-color: #42b0d5 !important;
}

.v-application .maersk-secondary-color {
  background-color: #00243d !important;
  border-color: #00243d !important;
}

.card-body{
  min-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.z-index.col{
  padding:0;
}
body {
  font-family: "Maersk Text" !important;
}
.v-application {
  font-family: "Maersk Text" !important;
  line-height: 1.5;
}
.required label::after {
  content: "*";
  color:red;
}
.required  .v-radio label::after {
  content: none !important;
  color:red;
}
.form-group label {
  display: block !important;
  max-width: 100%;
  margin-bottom: 5px !important;
  font-weight: 700;
  font-size: 14px;
}
.btnColor{
  background-color: #42b0d5;
}
.borderColor{
  border:1px solid #42b0d5;
}
.expand-color{
  background: #4b96a01a;
  padding: 8px 24px;
}
::-webkit-scrollbar {
  width: 10px;
  height:5px
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  background: #f1fbff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #878e94;
  border-radius: 10px;
}
.v-application .primary {
  background-color: #42b0d5 !important;
  border-color: #42b0d5 !important;
}
mc-icon{
  fill: #42b0d5 !important;
}
.v-progress-linear {
  width: 91% !important;
  margin-left: 9px !important;
}
.position-relative{
  position: relative;
}
.m-0{
  margin:0 !important;
}
.p-0{
  padding: 0 !important;
}
.pl-0{
  padding-left: 0!important;
}
pr-0{
  padding-right: 0!important;
}
.onScreenSizeChange{
  background: #ebedef !important;
}
.d-inline-block{
  display: inline-block;
}
.position-relative{
  position: relative;
}

</style>
